// eslint-disable-next-line import/no-import-module-exports
import React, { useEffect, useRef, useReducer } from 'react';
// eslint-disable-next-line import/no-import-module-exports
import ReactDayPicker, { DateUtils } from 'react-day-picker';
// eslint-disable-next-line import/no-import-module-exports
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-import-module-exports
import m from 'moment';
// eslint-disable-next-line import/no-import-module-exports
import 'moment/locale/ru';
// eslint-disable-next-line import/no-import-module-exports
import MomentLocaleUtils from 'react-day-picker/moment';

const _ = require('./i18n');

// clean moment objects from garbage and make time similar
const cleanDate = (obj) => m(`${obj.format('YYYY-MM-DD')}T09-00`)._d;

const initialState = {
  // allows see picked date. needs to be true for it
  init: false,
  validRange: false,
  visibility: false,
  prevRequest: null,
  currentMonth: m().month(),
  range: { from: null, to: null },
  currentRange: { from: null, to: null },
};

const compareObjects = (...objects) => {
  const strArray = objects.map((obj) => JSON.stringify(obj));
  if (strArray.every((str) => str === strArray[0])) return true;
  return false;
};

const monthIndex = {
  january: '0',
  february: '1',
  march: '2',
  april: '3',
  may: '4',
  june: '5',
  july: '6',
  august: '7',
  september: '8',
  october: '9',
  november: '10',
  december: '11',
};

const formatDate = (range = initialState.range, type = 'full') => {
  const isRange = (range.to) && !compareObjects(range.to, range.from);
  // rts == transform date object to string, r == range, f == format, d == devider
  const rts = (r, f, d) => Object.values(r).map((el) => m(el).format(f)).join(d);
  let output = '';
  if (compareObjects(range, initialState.range)) return `${_('Date')}`;
  switch (type) {
    case 'full': {
      output = isRange ? rts(range, 'D MMMM', ' — ') : m(range.from).format('D MMMM');
      break;
    }
    case 'mobile': {
      output = isRange ? `с ${rts(range, 'DD.MM', ' по ')}` : m(range.from).format('D MMMM');
      break;
    }
    case 'server': {
      output = isRange ? rts(range, 'YYYY-MM-DD', '-') : m(range.from).format('YYYY-MM-DD');
      break;
    }
    default:
      output = m(range.from).format('D MMMM');
  }
  return output;
};

const parseRangeObject = (string) => {
  const reg = /(\d+-\d+-\d+)/gm;
  const dt = string.match(reg);
  if (!dt) {
    const params = {};
    const prmarr = string.substr(1).split('&');
    for (let i = 0; i < prmarr.length; i++) {
      const tmparr = prmarr[i].split('=');
      // eslint-disable-next-line prefer-destructuring
      params[tmparr[0]] = tmparr[1];
    }
    if (params.date === 'today') {
      const from = cleanDate(m());
      const to = null;
      return { from, to };
    }
    if (monthIndex[params.date]) {
      let startDate;
      if ((Number(m().format('M')) - 1) === Number(monthIndex[params.date])) {
        startDate = m();
      } else {
        startDate = m([m().year(), monthIndex[params.date]]);
      }
      const endDate = m(startDate).endOf('month');
      const from = cleanDate(startDate);
      const to = cleanDate(endDate);
      return { from, to };
    }
    return initialState.range;
  }
  const from = cleanDate(m(dt[0]));
  let to = null;
  if (dt.length > 1) {
    to = cleanDate(m(dt[1]));
  }
  return { from, to };
};

const calendarReducer = (state, action) => {
  switch (action.type) {
    case 'setRangeOnMount': {
      if (!action.payload.range) {
        break;
      }
      const range = { ...action.payload.range };
      return {
        ...state,
        prevRequest: formatDate(range, 'server'),
        range,
        init: true,
      };
    }
    case 'toggle': {
      let currentRange = { from: null, to: null };
      if (!state.visibility) {
        currentRange = { ...state.range };
      }
      return {
        ...state,
        visibility: !state.visibility,
        currentRange,
        validRange: false,
      };
    }
    case 'hide': {
      const currentMonth = m().month();
      const currentRange = { from: null, to: null };
      return {
        ...state,
        currentMonth,
        visibility: false,
        currentRange,
        validRange: false,
      };
    }
    case 'onDayClick': {
      if (action.payload.e.target.classList.contains('DayPicker-Day--disabled')) {
        break;
      }
      const currentRange = DateUtils.addDayToRange(
        action.payload.day,
        state.currentRange,
      );
      let validRange = false;
      const request = formatDate(currentRange, 'server');
      if (currentRange.from && (request !== state.prevRequest)) {
        validRange = true;
      }
      return {
        ...state,
        currentRange,
        validRange,
      };
    }
    case 'onMonthChange': {
      const currentMonth = m(action.payload.month).month();
      const currentYear = m(action.payload.month).year();
      return {
        ...state,
        currentMonth,
        currentYear,
      };
    }
    case 'onMonthClick': {
      let validRange = true;
      const Y = state.currentYear ? state.currentYear : m().year();
      const M = state.currentMonth;
      const from = cleanDate(m([Y, M]));
      const to = cleanDate(m(from).endOf('month'));
      let currentRange = { from, to };
      if (m().month() === state.currentMonth) {
        currentRange = {
          from: cleanDate(m()),
          to: cleanDate(m().endOf('month')),
        };
      }
      if (compareObjects(currentRange, state.range)) {
        validRange = false;
      }
      return {
        ...state,
        currentRange,
        validRange,
      };
    }
    case 'apply': {
      if (!state.validRange) break;
      const currentMonth = m().month();
      const validRange = false;
      const range = state.currentRange;
      const request = formatDate(range, 'server');
      if (state.prevRequest !== request) {
        const ev = new CustomEvent('select', {
          bubbles: true,
          detail: { date: request },
        });
        action.payload.ref.current.dispatchEvent(ev);
      }
      return {
        ...state,
        currentMonth,
        prevRequest: request,
        range,
        visibility: false,
        init: true,
        currentRange: { from: null, to: null },
        validRange,
        apply: true,
      };
    }
    case 'feedModelUpdate': {
      let { range } = initialState;
      let init = false;
      if (action.payload.date) {
        init = true;
        let dataForParse = action.payload.date[0];
        if (action.payload.date[0] === 'today') {
          dataForParse = m().format('YYYY-MM-DD');
        } else if (monthIndex[action.payload.date[0]]) {
          let startDate;
          if ((Number(m().format('M')) - 1) === Number(monthIndex[action.payload.date[0]])) {
            startDate = m().format('YYYY-MM-DD');
          } else {
            startDate = m([m().year(), monthIndex[action.payload.date[0]]]).format('YYYY-MM-DD');
          }
          const endDate = m(startDate).endOf('month').format('YYYY-MM-DD');
          dataForParse = `${startDate}-${endDate}`;
        }
        range = parseRangeObject(dataForParse);
      }
      return {
        ...state,
        range,
        init,
        prevRequest: formatDate(range, 'server'),
      };
    }
    default:
      break;
  }
  return state;
};
function DayPicker({ isMobile }) {
  const [state, dispatch] = useReducer(calendarReducer, initialState);
  const wrapRef = useRef();

  const { visibility, range, currentRange } = state;

  useEffect(() => {
    if (window.location.search) {
      dispatch({ type: 'setRangeOnMount', payload: { range: parseRangeObject(window.location.search) } });
    }
    const closeWrapper = (e) => {
      if (!wrapRef || wrapRef.current.contains(e.target)) return;
      dispatch({ type: 'hide' });
    };

    const onModelUpdate = (e) => {
      const payload = e.detail.renderState ? e.detail.renderState : initialState.range;
      dispatch({ type: 'feedModelUpdate', payload });
    };
    document.addEventListener('feedModelUpdate', onModelUpdate);
    document.addEventListener('touchstart', closeWrapper);
    document.addEventListener('click', closeWrapper);
    return () => {
      document.removeEventListener('feedModelUpdate', onModelUpdate);
      document.removeEventListener('touchstart', closeWrapper);
      document.removeEventListener('click', closeWrapper);
    };
  }, []);

  // for fix ios bug
  useEffect(() => {
    const el = document.getElementById('mix-mobile-filters');
    if (el) {
      if (visibility) {
        el.style.overflow = 'visible';
      } else {
        el.style.overflow = 'auto';
      }
    }
  }, [visibility]);

  const { from, to } = currentRange;
  const modifiers = { start: from, end: to };

  const printDate = isMobile
    ? (
      <div className="df-sb-c">
        <span>{formatDate(range, 'mobile')}</span>
        <span className="react-date-picker--calendar-icon" />
      </div>
    )
    : formatDate(range, 'full');

  return (
    <div className={visibility ? 'DayPickerWrapper DayPickerWrapper-visibility' : 'DayPickerWrapper'} ref={wrapRef}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <div
        onClick={() => dispatch({ type: 'toggle' })}
        className="DayPicker-choosenDate navbar-item-link"
      >
        <span>{state.init ? printDate : `${_('Date')}`}</span>
        <img alt="arrow-down" style={{ marginLeft: 6 }} src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDExIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOS44Njg4NSAwLjM4NzEzM0MxMC4yMjMzIDAuNzU2NjQxIDEwLjIxMTEgMS4zNDM1MSA5Ljg0MTU2IDEuNjk3OTVMNS42NjQxNCA1LjcwNDk4QzUuMjk0MzkgNi4wNTk2NSA0LjcwNzEyIDYuMDQ3NDMgNC4zNTI0NSA1LjY3NzY3TDAuMzczMTAxIDEuNjk4MzNDMC4wMTEwNDk4IDEuMzM2MjcgMC4wMTEwNDk3IDAuNzQ5Mjc0IDAuMzczMTAxIDAuMzg3MjIyQzAuNzM1MTUyIDAuMDI1MTcxNCAxLjMyMjE1IDAuMDI1MTcxMyAxLjY4NDIgMC4zODcyMjJMNC4zNDMwNSAzLjA0NjA3QzQuNzI3ODQgMy40MzA4NiA1LjM0OTY4IDMuNDM3MzMgNS43NDIzOSAzLjA2MDYzTDguNTU4MDMgMC4zNTk4NDRDOC45Mjc1NCAwLjAwNTQwNjcgOS41MTQ0MSAwLjAxNzYyNDQgOS44Njg4NSAwLjM4NzEzM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=" />
      </div>
      {visibility && (
        <div className="DayPicker-container">
          <ReactDayPicker
            showOutsideDays
            fromMonth={new Date(m()._d)}
            onCaptionClick={() => dispatch({ type: 'onMonthClick' })}
            onDayClick={(day, _modifiers, e) => dispatch({ type: 'onDayClick', payload: { day, e } })}
            onMonthChange={(month) => dispatch({ type: 'onMonthChange', payload: { month, extra: ReactDayPicker.showPreviousMonth } })}
            modifiers={modifiers}
            localeUtils={MomentLocaleUtils}
            locale="ru"
            selectedDays={[from, { from, to }]}
            disabledDays={[{ before: m()._d }]}
          />
          <div className="text-center">
            {/* eslint-disable-next-line react/button-has-type */}
            <button
              className={state.validRange ? 'button' : 'button button-disabled'}
              onClick={() => dispatch({ type: 'apply', payload: { ref: wrapRef } })}
            >
              {_('Apply')}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

DayPicker.propTypes = {
  isMobile: PropTypes.bool,
};
DayPicker.defaultProps = {
  isMobile: false,
};

export default DayPicker;
module.exports = DayPicker;
